import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

/* Right now these actions are only used in the admin-only media library.
   If you access these methods anywhere other than the media library,
   we need to start using Redux. Add points to your story.
*/

export const getFileMetadata = (params) => {
    const { metadataId, pathsContext } = params;
    const url = `${pathsContext.adminServerUrl}/filesmetadata/${metadataId}`;
    return VerbFetch(url, {
        method: 'GET'
    });
};

export const getManyFilesMetadata = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/filesmetadata`;
    const url = buildQueryString(rest, baseUrl);
    return VerbFetch(url, {
        method: 'GET'
    }).then((data) => data);
};

export const updateFileMetadata = (params) => {
    const { fileMetadataId, updateParams, pathsContext } = params;
    const url = `${pathsContext.adminServerUrl}/filesmetadata/${fileMetadataId}`;
    return VerbFetch(url, {
        method: 'PUT',
        body: {
            ...updateParams
        }
    }).then((result) => result);
};
